const NON_MEMBERSHIP_FIELDS = new Set([
    'sortBy',
    'sortDir',
    'premiumTokenAddresses',
]);
const isEmptyValue = (value) => {
    if (value === undefined || value === null) {
        return true;
    }
    if (typeof value === 'boolean') {
        return value === false;
    }
    if (typeof value === 'string') {
        return value.trim().length === 0;
    }
    if (Array.isArray(value)) {
        return value.length === 0;
    }
    return false;
};
const canonicalize = (value) => {
    if (Array.isArray(value)) {
        return `[${[...value].map(String).sort().join(',')}]`;
    }
    if (value !== null && typeof value === 'object') {
        // Sorted keys so the hash stays key-order-independent for object-valued
        // filters (none today, but keeps the room key stable if one is added).
        return JSON.stringify(value, Object.keys(value).sort());
    }
    return String(value);
};
const stableHash = (input) => {
    let hash = 5381;
    for (let index = 0; index < input.length; index += 1) {
        hash = (hash * 33) ^ input.charCodeAt(index);
    }
    return (hash >>> 0).toString(36);
};
export const filtersHash = (filters) => {
    if (!filters) {
        return null;
    }
    const parts = [];
    for (const key of Object.keys(filters).sort()) {
        if (NON_MEMBERSHIP_FIELDS.has(key)) {
            continue;
        }
        const value = filters[key];
        if (isEmptyValue(value)) {
            continue;
        }
        parts.push(`${key}=${canonicalize(value)}`);
    }
    if (parts.length === 0) {
        return null;
    }
    return stableHash(parts.join('&'));
};
//# sourceMappingURL=filters-hash.js.map